/**
 * Minimal markdown -> HTML preview renderer.
 * Supports: # ## ### headings, - * bullets, **bold**, *italic*, plain paragraphs.
 */
export default function MarkdownPreview({ children, className = "" }) {
  const md = children || "";
  const html = renderMarkdown(md);
  return (
    <div
      className={`prose-cavilo ${className}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(s) {
  let out = escapeHtml(s);
  out = out.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  out = out.replace(/\*(.+?)\*/g, "<em>$1</em>");
  return out;
}

function renderMarkdown(md) {
  const lines = md.split("\n");
  const html = [];
  let listOpen = false;
  const closeList = () => { if (listOpen) { html.push("</ul>"); listOpen = false; } };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { closeList(); html.push(""); continue; }
    if (line.startsWith("### ")) { closeList(); html.push(`<h3>${inline(line.slice(4))}</h3>`); continue; }
    if (line.startsWith("## ")) { closeList(); html.push(`<h2>${inline(line.slice(3))}</h2>`); continue; }
    if (line.startsWith("# ")) { closeList(); html.push(`<h1>${inline(line.slice(2))}</h1>`); continue; }
    if (line.startsWith("- ") || line.startsWith("* ")) {
      if (!listOpen) { html.push("<ul>"); listOpen = true; }
      html.push(`<li>${inline(line.slice(2))}</li>`);
      continue;
    }
    closeList();
    html.push(`<p>${inline(line)}</p>`);
  }
  closeList();
  return html.join("\n");
}
